import { UNAUTHORIZED_CONNECT_TOOLTIP } from '../../constants';
import WithPermissions from './WithPermissions';

const WithConnectOrgPermission = (props: any) => (
  <WithPermissions
    permissionStr={['create:orgs:crm']}
    disabledTooltip={UNAUTHORIZED_CONNECT_TOOLTIP}
    {...props}
  />
);

export default WithConnectOrgPermission;
